module.exports = __webpack_public_path__ + "static/media/first-derivative.36f3bf19.jpg";